import React, { useEffect, useState } from 'react';
import axios from '../helpers/axiosConfig';

import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, Title, Tooltip, Legend, ArcElement } from 'chart.js';

ChartJS.register(Title, Tooltip, Legend, ArcElement);

const BrigadesPieChart = () => {
  const [chartData, setChartData] = useState({ labels: [], datasets: [] });
  const [brigadesData, setBrigadesData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get('/brigade/stats/Chart/c').then((response) => {
          setLoading(false);
          if (Array.isArray(response.data)) {
            setBrigadesData(response.data);
          }

          const labels = response.data.map((brigade) => brigade.brigadeName);
          const data = response.data.map((brigade) => brigade.personnelCount);

          setChartData({
            labels,
            datasets: [
              {
                label: 'Nombre de personnels par Brigade',
                data,
                backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF', '#FF9F40'],
                hoverBackgroundColor: ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF', '#FF9F40'],
              },
            ],
          });
        });
        //const brigadesData = response.data; // la réponse de l'API est un tableau d'objet imbriqué
        //const brigadesData = Object.entries(response.data).map(([key, value]) => value)
      } catch (error) {
        setLoading(false);
        console.error('Erreur lors de la récupération des données : ', error);
      }
    };

    fetchData();
  }, []);

  return (
    <div>
      {loading ? (
        <div className=" col text-center" style={{ textAlign: 'center', margin: '20px' }}>
          <img src="/images/laodinf-laoding.gif" alt="Chargement..." />
        </div>
      ) : (
        <div className="col mt-5 pt-3">
          <h3>Graphe en Secteur - Nombre de Personnels par Brigade</h3>
          <Pie data={chartData} />
        </div>
      )}
    </div>
  );
};

export default BrigadesPieChart;
